const steps = [
  {
    step: '01',
    icon: 'ri-list-check-2',
    title: 'Choose Your Category',
    description:
      'Start by picking a product category that interests you — from Shoes and Hoodies to Jackets, Accessories, and more. Every category is organized for quick browsing.',
    examples: 'Shoes, Hoodies, Jackets, Accessories',
  },
  {
    step: '02',
    icon: 'ri-arrow-left-right-line',
    title: 'Compare Available Options',
    description:
      'Browse through the organized product listings and compare features, styles, and categories side by side. The spreadsheet format makes it easy to spot differences at a glance.',
  },
  {
    step: '03',
    icon: 'ri-shopping-bag-3-line',
    title: 'Make Better Decisions',
    description:
      'With all the information organized in one place, you can confidently choose the products that best match your needs and preferences, then head to the store to complete your purchase.',
  },
];

export default function HowItWorks() {
  return (
    <section id="how-it-works" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900 mb-4">
            How VigorBuy Spreadsheet Works
          </h2>
          <p className="text-foreground-500 max-w-2xl mx-auto leading-relaxed">
            Getting started is simple. Follow these three easy steps to transform the way you research and discover
            products online.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative">
          {steps.map((item, idx) => (
            <div key={item.step} className="relative text-center">
              {idx < steps.length - 1 && (
                <div className="hidden md:block absolute top-12 left-[calc(50%+4rem)] w-[calc(100%-8rem)] h-[2px] bg-gradient-to-r from-primary-200 to-transparent"></div>
              )}
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-primary-500 text-white mb-5">
                <i className={`${item.icon} text-2xl`}></i>
              </div>
              <span className="block text-xs font-bold text-primary-500 uppercase tracking-widest mb-2">
                Step {item.step}
              </span>
              <h3 className="font-heading font-semibold text-lg text-foreground-900 mb-3">{item.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed max-w-xs mx-auto">{item.description}</p>
              {item.examples && (
                <div className="mt-4 inline-flex flex-wrap gap-2 justify-center">
                  {item.examples.split(', ').map((ex) => (
                    <span
                      key={ex}
                      className="px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium whitespace-nowrap"
                    >
                      {ex}
                    </span>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}